export type ToggleNotificationRequest = {
    customerId: number
    relatedId: number
    relatedType: string
}

export type ToggleNotificationResponse = {
    // eslint-disable-next-line camelcase
    is_enable_notification: boolean
}

export enum RelatedType {
    CATEGORY = 'category', // artist
    ARTIST_GROUP = 'artist_group',
    FAN_CLUB = 'fan_club',
}
